// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import sl from 'vuetify/es5/locale/sl'

Vue.use(Vuetify)

export default new Vuetify({
    lang: {
        locales: {
            sl
        },
        current: 'sl',
    }
});
